import React, { useEffect } from 'react';

const Toast = ({ message, type, onClose }) => {
  useEffect(() => { const t = setTimeout(onClose, 4000); return () => clearTimeout(t); }, [onClose]);
  return (
    <div className={`toast ${type}`}>
      <i className={`fas fa-${type === "success" ? "check-circle" : type === "info" ? "info-circle" : "exclamation-circle"}`}></i>
      <span>{message}</span>
    </div>
  );
};

export default Toast;
